import * as yup from 'yup';

import { VerifierCredentialStatus } from 'src/api';

import { VerifyManuallyModalFields, VerifyManuallyModalValues } from '../types';

export const verifyAutomaticModalFormValidationSchema = yup.object({
  [VerifyManuallyModalFields.denialReason]: yup
    .string()
    .nullable()
    .test((denialReason, context) => {
      const values = context.options.context?.formValues as VerifyManuallyModalValues;

      if (values.status === VerifierCredentialStatus.Denied && !denialReason?.trim()) {
        return context.createError({ message: 'Field is required' });
      }
      return true;
    }),
});
